import { render, staticRenderFns } from "./VNav.vue?vue&type=template&id=c46c449c&scoped=true"
import script from "./VNav.vue?vue&type=script&lang=js"
export * from "./VNav.vue?vue&type=script&lang=js"
import style0 from "./VNav.vue?vue&type=style&index=0&id=c46c449c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46c449c",
  null
  
)

export default component.exports